<template>
    <form-row>
        <div class="flex flex-col sm:flex-row sm:items-end">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="entitlement_date"
                    v-model="entitlement_date"
                    :read_only="read_only"
                    @entered="dateEntered"
                />
            </div>

            <div class="mt-4 sm:mt-0 flex items-center">
                <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="flex-none w-16 sm:w-1/5">
                    <input-text
                        name="entitlement_period"
                        v-model="entitlement_period"
                        placeholder="Days"
                        :read_only="read_only"
                        @input="periodEntered"
                    />
                </div>

                <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                    {{ $t('days after Contract “Binding” Acceptance') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        entitlement_extend_days: {},
        read_only: { default: false },
    },

    data() {
        return {
            entitlement_period: this.commercial.entitlement_period,
        }
    },

    computed: {
        entitlement_date_from_period() {
            if (! store.state.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(store.state.contract_acceptance_date) && this.entitlement_period) {
                return dayjs(store.state.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.entitlement_period })
                    .format('YYYY-MM-DD');
            }
        },
        entitlement_date: {
            get() {
                return store.state.entitlement_date;
            },
            set(val) {
                store.state.entitlement_date = val;
            },
        },
    },

    methods: {
        dateEntered() {
            this.entitlement_period = null;
        },
        periodEntered(value) {
            if (! value || ! store.state.contract_acceptance_date) {
                this.entitlement_date = null;
            }
        },
    },

    watch: {
        entitlement_date_from_period(val) {
            if (val) {
                this.entitlement_date = val;
            }
        },
        entitlement_date(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
